import {Constants} from "../constants";
import {ApiError, ApiService} from "./api.service";


export const DoorPositionEnum = {
    OPEN: 1,
    CLOSED: 2
}

export const LevelerPositionEnum = {
    RETRACTED: 1,
    DOWN: 2,
    NOT_EQUIPED: 3
}
const DockStatusService = {

    getDockStatus: async function(locationId) {
        try {
            const endpoint = `${Constants.ENDPOINT_ASSA_ABLOY}/${locationId}`
            const response = await ApiService.get(endpoint)
            return response.data
        }catch(error) {
            throw new ApiError(error)
        }
    },
}

export { DockStatusService }